/**
 * @description  Tag manager events
 */
export default Object.freeze({
  WIDGET_READY: 'innsoWidgetReady',
  WIDGET_STATE_CHANGE: 'innsoWidgetStateChange',
  WIDGET_STATE_CHANGE_FAIL: 'innsoWidgetStateChangeFail',
  WIDGET_START_CHAT: 'innsoWidgetStartChat',
  WIDGET_START_CHAT_FAIL: 'innsoWidgetStartChatFail',
  WIDGET_CLOSED: 'innsoWidgetClosed',
  WIDGET_NEW_INCOMING_MESSAGE: 'innsoWidgetNewIncomingMessage',
})
